<template>
    <div class="file-row hoverlistitem">
        <a class="file-link" :href="file.Link" target="_blank" rel="noopener">
            <v-icon size="16" class="mr-2">{{ typeIcon() }}</v-icon>
            <span class="file-name">{{ file.Name }}</span>
        </a>
        <div v-if="deleteFunc != undefined" class="hiddenBeforeHoverContent file-delete">
            <v-btn icon small @click.stop="deleteFunc(file)">
                <v-icon size="18">mdi-close</v-icon>
            </v-btn>
        </div>
    </div>
</template>


<script>
export default {
    name: 'File',
    props: {
        file: Object,
        deleteFunc: Function,
    },
    components: {},

    data() {
        return {
            DocumentTypes: {
                LINK: 1,
                FORM: 2,
                PARTDRAWING: 3,
            },
        };
    },

    methods: {
        typeIcon() {
            if (this.file.IsMedia) {
                return 'mdi-file-image';
            }
            else if (this.file.TypeId == this.DocumentTypes.FORM) {
                return 'mdi-file-document-edit';
            }
            else if (this.file.TypeId == this.DocumentTypes.PARTDRAWING) {
                return 'mdi-file-cad';
            }
            else {
                return 'mdi-file-document';
            }
        }
    },

    computed: {

    },

    watch: {},
};
</script>


<style lang='scss' scoped>
.file-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 34px;
    padding: 2px 4px;
}

.file-link {
    display: inline-flex;
    align-items: center;
    color: inherit;
    text-decoration: none;
    min-width: 0;
    flex: 1;
}

.file-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.file-delete {
    margin-left: 4px;
    display: inline-flex;
    align-items: center;
}

.file-delete :deep(.v-btn) {
    width: 28px;
    height: 28px;
    min-width: 28px;
    box-shadow: none !important;
    background: transparent !important;
}

.fileText {
    font-size: 12px;
    opacity: 0.9;
    overflow-wrap: break-word;
    inline-size: 100px;
    line-clamp: 3;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-align: center;
}

.hoverlistitem:hover .hiddenBeforeHoverContent {
    display: block;
}

.hoverlistitem .hiddenBeforeHoverContent {
    display: none;
}
</style>